export const CLEAR_BRANCHES = 'CLEAR_BRANCHES';
export const SET_BRANCHES = 'SET_BRANCHES';
export const ADD_BRANCH = 'ADD_BRANCH';
export const EDIT_BRANCH = 'EDIT_BRANCH';
export const DELETE_BRANCH = 'DELETE_BRANCH';
export const UPDATE_BRANCHES_PRESENCE = 'UPDATE_BRANCHES_PRESENCE';
